import script from "./Precificacao.vue?vue&type=script&setup=true&lang=js"
export * from "./Precificacao.vue?vue&type=script&setup=true&lang=js"

import "./Precificacao.vue?vue&type=style&index=0&id=412be123&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-412be123"]])

export default __exports__